import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useAuth } from "@/auth/AuthContext";

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="border-b">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button asChild variant="ghost" size="sm">
            <Link to="/">Math</Link>
          </Button>
        </div>

        <nav className="hidden md:flex gap-2 items-center">
          <Button asChild variant="ghost" size="sm">
            <Link to="/rounding">Rounding</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/multiplication">Multiplication</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/conversion">Conversion</Link>
          </Button>
          {user?.role === "admin" && (
            <Button asChild variant="ghost" size="sm">
              <Link to="/admin">Admin</Link>
            </Button>
          )}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden md:flex items-center gap-2">
            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="flex items-center gap-2 px-2 py-1 rounded-sm hover:bg-accent">
                    <Avatar size="sm">
                      <AvatarFallback>{user.username.slice(0, 2).toUpperCase()}</AvatarFallback>
                    </Avatar>
                    <span className="hidden sm:inline text-sm">{user.username}</span>
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem onClick={() => logout()}>Sign out</DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Button asChild>
                <Link to="/login">Sign in</Link>
              </Button>
            )}
          </div>

          <div className="md:hidden">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm" aria-label="Open menu">
                  <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
                    <path
                      fillRule="evenodd"
                      d="M3 5h14a1 1 0 100-2H3a1 1 0 000 2zm0 6h14a1 1 0 100-2H3a1 1 0 000 2zm0 6h14a1 1 0 100-2H3a1 1 0 000 2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Button>
              </SheetTrigger>

              <SheetContent side="right">
                <SheetHeader>
                  <SheetTitle>Menu</SheetTitle>
                </SheetHeader>

                <div className="p-4 flex flex-col gap-2">
                  <Button asChild variant="ghost">
                    <Link to="/">Home</Link>
                  </Button>
                  <Button asChild variant="ghost">
                    <Link to="/user">User</Link>
                  </Button>
                  <Button asChild variant="ghost">
                    <Link to="/rounding">Rounding</Link>
                  </Button>
                  <Button asChild variant="ghost">
                    <Link to="/multiplication">Multiplication</Link>
                  </Button>
                  <Button asChild variant="ghost">
                    <Link to="/conversion">Conversion</Link>
                  </Button>
                  {user?.role === "admin" && (
                    <Button asChild variant="ghost">
                      <Link to="/admin">Admin</Link>
                    </Button>
                  )}

                  {user ? (
                    <Button variant="destructive" onClick={() => logout()}>
                      Sign out
                    </Button>
                  ) : (
                    <Button asChild>
                      <Link to="/login">Sign in</Link>
                    </Button>
                  )}
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
